import { LotCardItemProps } from '@nx/global-types'
import { SetValue, useLocalStorage } from '@nx/hooks/use-local-storage'

export function useMigrateRecentlyViewedLots(
  recentlyViewedLotIds: number[],
  setRecentlyViewedLotIds: SetValue<number[]>
) {
  const [oldRecentlyViewedLots, , removeValue] = useLocalStorage<
    LotCardItemProps[]
  >('recentlyViewedLots', [])

  if (oldRecentlyViewedLots.length && !recentlyViewedLotIds.length) {
    // we have not migrated the old local storage to the new one
    setRecentlyViewedLotIds(
      oldRecentlyViewedLots.map((lot) => Number(lot.lotUniqueId))
    )
    removeValue()
  }
}
